import { useCallback } from 'react'
import { HugeiconsIcon } from '@hugeicons/react'
import { Delete02Icon } from '@hugeicons/core-solid-rounded'

import { ButtonRowInput } from './ButtonRowInput'
import { ButtonRow } from '../types'

export function MultipleButtonRowInput({
  onChange,
  value
}: {
  value: ButtonRow[]
  onChange: (values: ButtonRow[]) => void
}) {
  const onAdd = useCallback(
    (row: ButtonRow) => {
      onChange([...value, row])
    },
    [value, onChange]
  )

  const onUpdate = useCallback(
    (index: number, row: ButtonRow) => {
      const newValue = value.map((value, idx) => {
        if (idx === index) return row
        return value
      })

      onChange(newValue)
    },
    [value, onChange]
  )

  const onRemove = useCallback(
    (index: number) => {
      onChange(value.filter((_, i) => i !== index))
    },
    [value, onChange]
  )

  return (
    <div className="flex flex-col gap-4">
      {value.map(function (value, index) {
        return (
          <div key={index} className="flex flex-row items-center gap-2">
            <div className="flex-1">
              <ButtonRowInput
                key={index}
                onChange={value => onUpdate(index, value)}
                value={value}
              />
            </div>
            <button type="button" onClick={() => onRemove(index)}>
              <HugeiconsIcon
                icon={Delete02Icon}
                className="size-5 text-red-500"
              />
            </button>
          </div>
        )
      })}
      <ButtonRowInput onChange={onAdd} />
    </div>
  )
}
